import { render, staticRenderFns } from "./ListGroupItem.vue?vue&type=template&id=2fdeea68&scoped=true&"
import script from "./ListGroupItem.vue?vue&type=script&lang=js&"
export * from "./ListGroupItem.vue?vue&type=script&lang=js&"
import style0 from "./ListGroupItem.vue?vue&type=style&index=0&id=2fdeea68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdeea68",
  null
  
)

export default component.exports